import {AfterViewInit, Component, OnInit} from '@angular/core';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {fabric} from 'fabric';
import {PrismObject, PRISMResult} from '../../../../model/questionnaires/questionnaire-prism';

@Component({
  selector: 'app-questionnaire-prism',
  templateUrl: './questionnaire-prism.component.html',
  styleUrls: ['./questionnaire-prism.component.css']
})
export class QuestionnairePrismComponent implements OnInit, AfterViewInit {

  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  results = [];
  found = false;
  finalScore = 0;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'PRISM';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;
  canvas: any;
  self: PrismObject;
  disease: PrismObject;
  distance: number;

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) {}

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });

    this.self = new PrismObject(500, 200);
    this.disease = new PrismObject(40, 40);
    // tslint:disable-next-line:max-line-length
    this.distance = parseFloat((Math.hypot(this.self.x - this.disease.x,
      this.self.y - this.disease.y) * 0.026458).toFixed(1));

    console.log('start distance: ', this.distance);
  }

  ngAfterViewInit(): void {
    const canvas = new fabric.Canvas('canvas');
    const disease = new fabric.Circle({
      radius: 30, left: 40, top: 40, fill: '#cc0000',
      originX: 'center', originY: 'center',
      hasControls: false, hasBorders: false, hoverCursor: 'pointer', moveCursor: 'pointer',
      stroke: '#990000', strokeWidth: 2
    });

    const self = new fabric.Circle({
      radius: 50, left: 500, top: 200, fill: '#ffe014', hasControls: false, hasBorders: false,
      originX: 'center', originY: 'center',
      evented: false, stroke: '#ffc414', strokeWidth: 2
    });

    canvas.add(self, disease);
    canvas.selection = false;
    canvas.on({
      'object:moving': e => {
        const circle = canvas.getActiveObject();
        const x1 = circle.left;
        const y1 = circle.top;
        const x2 = 500;
        const y2 = 200;
        const distance = parseFloat((Math.hypot(x2 - x1, y2 - y1) * 0.026458).toFixed(1));
        console.log('Distance in cm: ', distance);
        const selfObj = new PrismObject(x2, y2);
        const diseaseObj = new PrismObject(x1, y1);
        this.self = selfObj;
        this.disease = diseaseObj;
        this.distance = distance;
        console.log('log', this.self, this.disease, this.distance);
      }
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;
    const resultToSend = new PRISMResult(this.doctorID, this.patientSSN, this.self, this.disease, this.distance.toFixed(2));
    this.questionnaireService.sendForm(resultToSend, 'prism', this.uuid);
  }
}
